var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputAdornment } from '@mui/material';
import BaseButton from '../../components/atoms/BaseButton';
function useDirectlyUpdatableTextField(Component) {
    var ResultComponent = React.useMemo(function () {
        var DirectlyUpdatableComponent = function (_a) {
            var value = _a.value, multiline = _a.multiline, disabled = _a.disabled, onUpdate = _a.onUpdate, name = _a.name, onChange = _a.onChange, transformValue = _a.transformValue, otherProps = __rest(_a, ["value", "multiline", "disabled", "onUpdate", "name", "onChange", "transformValue"]);
            var t = useTranslation().t;
            var _b = React.useState(value), currentValue = _b[0], setCurrentValue = _b[1];
            var handleChange = React.useCallback(function (value) {
                var updatedValue = transformValue ? transformValue(value) : value;
                if (onChange) {
                    onChange(updatedValue);
                }
                setCurrentValue(updatedValue);
            }, [onChange, transformValue]);
            var handleKeyDown = function (ev) {
                if (!multiline && ev.key === 'Enter') {
                    onUpdate(currentValue, name);
                }
            };
            var handleUpdateButton = function () { return onUpdate(currentValue, name); };
            var props = {
                value: currentValue,
                onChange: handleChange,
                onKeyDown: handleKeyDown,
                multiline: multiline,
                disabled: disabled,
                endAdornment: (React.createElement(InputAdornment, { position: "end" },
                    React.createElement(BaseButton, { disabled: disabled, onClick: handleUpdateButton }, t('buttons.update')))),
            };
            return React.createElement(Component, __assign({}, props, otherProps));
        };
        return DirectlyUpdatableComponent;
    }, [Component]);
    ResultComponent.displayName = "DirectlyUpdatable".concat(Component.displayName);
    return ResultComponent;
}
export default useDirectlyUpdatableTextField;
